import { render } from "./CSwitch.vue?vue&type=template&id=ed8b8d94"
import script from "./CSwitch.vue?vue&type=script&lang=js"
export * from "./CSwitch.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__